// Libs
import React from 'react';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import TextHelpers from 'helpers/TextHelpers';

//-------------------------------------------------------------------------------------------------------------------

class Calendar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    shouldComponentUpdate(nextProps) {
        if (typeof (this.props.requestID) == 'undefined') {
            return true;
        }
        return (this.props.requestID != nextProps.requestID);
    }

    render() {
        const {
            instructors,
            calendar
        } = this.props;

        // Determine if we can edit bookings
        const loginInfo = GlobalStateService.getValue('loginInfo');
        const isEditable = loginInfo.isAdmin;

        // Determine which instructors have changed their availability recently
        const instructorsWithChanges = {};
        for (var i = 0; i < calendar.weeks.length; i++) {
            const week = calendar.weeks[i];
            for (var j = 0; j < instructors.length; j++) {
                const instructor = instructors[j];
                const instructorWeek = week.instructors[instructor.id];
                if (instructorWeek && instructorWeek.anyChanges) {
                    instructorsWithChanges[instructor.id] = true;
                }
            }
        }

        // No results?
        if (instructors.length == 0) {
            return (
                <div className="empty-text">
                    Sorry, no matching instructors were found
                </div>
            );
        }

        return (<>
            
            <table className={`table sticky-table calendar ${isEditable ? 'editable' : ''}`}>
                <thead>
                    <tr>
                        {/*<th className="sticky-column">Week</th>*/}
                        <th className="sticky-column">Date</th>
                        {instructors.map(instructor =>
                            <th key={instructor.id} className={instructorsWithChanges[instructor.id] ? 'has-changes' : ''}>
                                <a href={`/instructor/${instructor.slug}`} target="_blank">
                                    {TextHelpers.formatInstructorName(instructor)}

                                    {!!instructor.bookingNotes &&
                                        <button className="btn btn-sm btn-danger ms-2" title={instructor.bookingNotes || ''}>
                                            <span className="fa fa-triangle-exclamation" />
                                        </button>
                                    }
                                </a>
                                <div className="tags block">
                                    {TextHelpers.getInstructorTags(instructor)}
                                </div>
                                <div className="instructor-geos">
                                    ({instructor.geos.map((geo, index) =>
                                        <React.Fragment key={index}>
                                            {index != 0 && ', '}
                                            {geo.isPrimary ? <b>{geo.name}</b> : geo.name}
                                        </React.Fragment>)
                                    })
                                </div>
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {calendar.weeks.map((week, index) =>
                        <React.Fragment key={moment(week.weekCommencing).format('YYYY-MM-DD')}>
                            {week.dates.map(date =>
                                <tr key={moment(date).format('YYYY-MM-DD')}>
                                    <th className="date-column">
                                        <div className="d-flex">
                                            <span className="me-auto week-number">{week.weekNumber}</span>
                                            {moment(date).format('DD/MM/YYYY')}
                                        </div>
                                    </th>
                                    {instructors.map(instructor =>
                                        this.renderInstructor(week, date, instructor, isEditable)
                                    )}
                                </tr>
                            )}
                            {index < calendar.weeks.length - 1 &&
                                <tr className="spacer-row">
                                    <td colSpan={2 + instructors.length}>
                                        &nbsp;
                                    </td>
                                </tr>
                            }
                        </React.Fragment>
                    )}
                </tbody>
            </table>

        </>);
    }

    renderInstructor(week, date, instructor, isEditable) {
        const {
            onEditBooking,
            calendar
        } = this.props;
        const dateKey = moment(date).format('YYYY-MM-DD');

        let instructorInfo = week.instructors[instructor.id];
        if (!instructorInfo) {
            instructorInfo = {
                availableDates: {},
                activeDates: {},
                holdDates: {},
                enquiryDates: {},
                addedDates: {},
                tentativeDates: {},
                removedDates: {},
                specialAvailabilityDates: {},
                bookingIDs: {},
                notes: {}
            };
        }

        //const isAdded = instructorInfo.addedDates[dateKey];
        //const isRemoved = instructorInfo.removedDates[dateKey];
        const status = (
            instructorInfo.activeDates[dateKey] ? 'active' :
            instructorInfo.tentativeDates[dateKey] ? 'tentative' :
            instructorInfo.holdDates[dateKey] ? 'hold' :
            instructorInfo.enquiryDates[dateKey] ? 'enquiry' :
            instructorInfo.availableDates[dateKey] ? 'available' :
            instructorInfo.specialAvailabilityDates[dateKey] == 'DefinitelyNotAvailable' ? 'definitely-not-available' :
            instructorInfo.specialAvailabilityDates[dateKey] == 'StealthVendor' ? 'stealth-date-vendor' :
            instructorInfo.specialAvailabilityDates[dateKey] == 'StealthOther' ? 'stealth-date-other' :
            'not-available'
        );
        const booking = instructorInfo.bookings && instructorInfo.bookings[dateKey] ? instructorInfo.bookings[dateKey] : {};
        const notes = instructorInfo.notes && instructorInfo.notes[dateKey];

        return (
            <td key={instructor.id}>
                <div className="cell-inner">

                    {status == 'tentative' &&
                        <div className="instructor-status tentative" onClick={() => isEditable && onEditBooking({
                            bookingID: booking.id
                        })}>
                            Tentative{booking.isATPBooking ? ' (ATP)' : ''}{booking.lmsid && <>: {booking.lmsid}</>}
                        </div>
                    }

                    {status == 'hold' &&
                        <div className="instructor-status hold" onClick={() => isEditable && onEditBooking({
                            bookingID: booking.id
                        })}>
                            Hold{booking.isATPBooking ? ' (ATP)' : ''}{booking.lmsid && <>: {booking.lmsid}</>}
                        </div>
                    }

                    {status == 'active' &&
                        <div className="instructor-status active" onClick={() => isEditable && onEditBooking({
                            bookingID: booking.id
                        })}>
                            Active{booking.isATPBooking ? ' (ATP)' : ''}{booking.lmsid && <>: {booking.lmsid}</>}
                        </div>
                    }

                    {status == 'enquiry' &&
                        <div className="instructor-status enquiry" onClick={() => isEditable && onEditBooking({
                            bookingID: booking.id
                        })}>
                            Enquiry: {booking.lmsid && <>{booking.lmsid}</>}
                            {booking.uniqueRef && <> ({booking.uniqueRef})</>}
                        </div>
                    }

                    {status == 'definitely-not-available' &&
                        <div className="instructor-status definitely-not-available">
                            Definitely not available
                        </div>
                    }

                    {status == 'stealth-date-vendor' &&
                        <div className="instructor-status stealth-date">
                            Stealth available (Vendor)

                            {!!notes &&
                                <span className="fa fa-comment availability-notes-icon" title={notes} />
                            }
                        </div>
                    }

                    {status == 'stealth-date-other' &&
                        <div className="instructor-status stealth-date">
                            Stealth available (other)

                            {!!notes &&
                                <span className="fa fa-comment availability-notes-icon" title={notes} />
                            }
                        </div>
                    }

                    {status == 'not-available' &&
                        <div className="instructor-status unavailable">
                            Not available
                        </div>
                    }

                    {status == 'available' &&
                        <div className="instructor-status available" onClick={() => {
                            onEditBooking({
                                instructorID: instructor.id,
                                date,
                                status: 'Hold'
                            });
                        }}>
                            Available
                        </div>
                    }

                    {/*
                    {isAdded &&
                        <div className="instructor-status availability-added" title={`Added since ${moment(calendar.lastExportDate).format('DD/MM/YYYY')}`}>
                            Added
                        </div>
                    }
                    {isRemoved &&
                        <div className="instructor-status availability-removed" title={`Remove since ${moment(calendar.lastExportDate).format('DD/MM/YYYY')}`}>
                            Removed
                        </div>
                    }
                    */}
                </div>
            </td>
        );
    }
}

export default Calendar;